'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { ArrowRight, ChevronDown, Factory, MapPin } from 'lucide-react'

export function HeroSection() {
    return (
        <section className="relative flex min-h-[100vh] items-center justify-center overflow-hidden">
            {/* ベージュ/ブラウンのグラデーション背景 */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#BEB0A8] via-[#D4C4B8]/30 to-background">
                {/* タイル風パターン背景 */}
                <div
                    className="absolute inset-0 opacity-20"
                    style={{
                        backgroundImage: `
              radial-gradient(circle at 25% 25%, hsl(30, 20%, 70%) 0%, transparent 50%),
              radial-gradient(circle at 75% 75%, hsl(25, 25%, 65%) 0%, transparent 50%)
            `,
                        backgroundSize: '400px 400px',
                        animation: 'float 20s ease-in-out infinite alternate'
                    }}
                />
            </div>

            <div className="container relative z-10 px-4 md:px-8">
                <div className="mx-auto max-w-5xl text-center">
                    <h1
                        className="font-['Shippori_Mincho_B1',_serif] leading-[40px] md:leading-[93px] text-[28px] md:text-[60px] text-[#292623] tracking-[2px] md:tracking-[6px] font-bold"
                    >
                        <span style={{ whiteSpace: 'nowrap' }}>地域にデジタルの誇りを。</span>
                    </h1>

                    <p
                        className="animate-fade-up mt-6 font-['Noto_Sans_JP',_sans-serif] font-medium leading-[28px] md:leading-[38px] text-[14px] md:text-[18px] text-[#292623] tracking-[1px] md:tracking-[2.268px] max-w-4xl mx-auto"
                        style={{ animationDelay: '0.2s', animationFillMode: 'backwards' }}
                    >
                        地域の文化と誇りを、デジタルの力で
                        <br className="hidden md:block" />
                        経済的な価値に変えていきます
                    </p>

                    {/* CTAボタン */}
                    <div
                        className="animate-fade-up mt-12 flex flex-col gap-6 items-center"
                        style={{ animationDelay: '0.4s', animationFillMode: 'backwards' }}
                    >
                        {/* メインCTA */}
                        <Button asChild size="lg" className="group px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all bg-[#292623] text-white hover:bg-[#292623]/90 font-['Noto_Sans_JP',_sans-serif]">
                            <Link href="/contact?type=consultation">
                                まず相談する
                                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                            </Link>
                        </Button>

                        {/* サブCTA */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <Button asChild variant="ghost" size="lg" className="group text-base hover:bg-[#292623]/10 text-[#292623] font-['Noto_Sans_JP',_sans-serif]">
                                <Link href="/digital-pride">
                                    <MapPin className="mr-2 h-5 w-5" />
                                    拠点を見る
                                </Link>
                            </Button>
                            <Button asChild variant="ghost" size="lg" className="group text-base hover:bg-[#292623]/10 text-[#292623] font-['Noto_Sans_JP',_sans-serif]">
                                <Link href="/ai-factory">
                                    <Factory className="mr-2 h-5 w-5" />
                                    AI工場を見る
                                </Link>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* スクロールインジケーター */}
            <div
                className="animate-fade-in absolute bottom-8 left-1/2 transform -translate-x-1/2"
                style={{ animationDelay: '1s', animationDuration: '1s', animationFillMode: 'backwards' }}
            >
                <div
                    className="flex flex-col items-center text-[#292623]/60"
                    style={{ animation: 'float-y 2s ease-in-out infinite' }}
                >
                    <span className="font-['Noto_Sans_JP',_sans-serif] text-sm mb-2 hidden sm:block">スクロール</span>
                    <ChevronDown className="h-5 w-5" />
                </div>
            </div>
        </section>
    )
}
